import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NearbyOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"nearby_off"}/>
}
